// hooks/useLangueEtudiee.js
// Lecture centralisée du paramètre WP `langueEtudiee` (fr/es/en), transmis via l'URL de l'iframe.
// Valide la valeur reçue : si absente ou invalide, retourne null (chaque page applique ensuite son propre repli).

import { useSearchParams } from 'react-router-dom';

const LANGUES_VALIDES = ['fr', 'es', 'en'];

export function useLangueEtudiee() {
  const [searchParams] = useSearchParams();
  const valeur = searchParams.get('langueEtudiee');
  return LANGUES_VALIDES.includes(valeur) ? valeur : null;
}
